<div
  class="loader-container"
  [class.fullscreen]="fullscreen()"
>
  <div
    class="loader"
    [class]="'loader-' + size()"
  >
    <div class="spinner"></div>
  </div>
</div>
